import {
	captureCampaignFromLocation,
	refreshCampaignActivity,
	syncCampaignToSessionStorage
} from '~/composables/adCampaign/utils';
import {
	refreshSessionActivity,
	syncSessionToSessionStorage
} from '~/composables/visitorIdentity/utils';

/**
 * Client-side plugin that runs once during hydration to:
 * 1. Sync campaign + session data from the localStorage bridge into
 *    sessionStorage (covers new tabs opened via target="_blank")
 * 2. Capture UTM params from the landing URL (fills the SSR hydration gap)
 * 3. Refresh the bridge timestamps (inactivity heartbeat)
 *
 * Campaign capture reads `window.location` (not `useRoute()`) so it is safe
 * behind a shared CDN cache: during hydration `useRoute()` can reflect another
 * visitor's cached SSR payload, while `window.location` is always THIS visitor's
 * real URL. This is what allows the CloudFront cache to ignore tracking params.
 */
export default defineNuxtPlugin(() => {
	syncCampaignToSessionStorage();
	syncSessionToSessionStorage();
	captureCampaignFromLocation();
	refreshCampaignActivity();
	refreshSessionActivity();
});
